module.exports = __webpack_public_path__ + "img/GEDIA_80X30.dfe1bcbd.png";